/**
 * The optional browsing history is available only after explicit personalization consent.
 * Shopify's consent API owns the decision; this module never writes consent cookies.
 */
function loadCustomerPrivacy() {
  return new Promise((resolve) => {
    if (window.Shopify?.customerPrivacy) return resolve();
    if (!window.Shopify?.loadFeatures) return resolve();
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => resolve());
  });
}

export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;
  static ready = loadCustomerPrivacy();

  static isAllowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.currentVisitorConsent().preferences === 'yes' &&
        privacy.preferencesProcessingAllowed() === true;
    } catch {
      return false;
    }
  }

  static async addProduct(productId) {
    await this.ready;
    if (!this.isAllowed() || !productId) return;
    const id = String(productId);
    const products = this.getProducts().filter((value) => value !== id);
    products.unshift(id);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(products.slice(0, this.#MAX_PRODUCTS)));
    } catch {
      // Browsing and buying remain available when storage is blocked.
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {}
  }

  static getProducts() {
    if (!this.isAllowed()) return [];
    try {
      const products = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(products)
        ? products.filter((id) => typeof id === 'string').slice(0, this.#MAX_PRODUCTS)
        : [];
    } catch {
      return [];
    }
  }
}

RecentlyViewed.ready.then(() => {
  if (!RecentlyViewed.isAllowed()) RecentlyViewed.clearProducts();
});

document.addEventListener('visitorConsentCollected', () => {
  if (!RecentlyViewed.isAllowed()) RecentlyViewed.clearProducts();
});
